import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IdentityUsersService } from 'src/app/services/identityUsers.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-whiteLabelProvidersList',
  templateUrl: './whitelabelproviderslist.component.html'
})
export class WhiteLabelProvidersListComponent {
  
  @Input('whitelabelproviders') whitelabelproviders!: any[];
  @Input('filter') filter: string = <string>{};
  @Output('triggerAction') triggerAction = new EventEmitter();
  translations = <any>{};
  hover: boolean = false;
  itemsPerPage: number = 10;
  pageSize!: number;
  currentPage: number = 1;
  columnName: string = 'name';
  orderBy: string = 'asc';
  descending: boolean = false;
  filterWhiteLabelProvider = { count: -1 };
  filteredWhiteLabelProviders: any[] = [];
  columns: string[] = ['name', 'organisationCount', 'licencesCount'];

  onPageChanged(pageNum: any): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }

  changePagesize(num:number): void {
    this.itemsPerPage = num;
  }

  sortData(column: string) {
    if (this.columnName == column) {
      this.descending = !this.descending;
    } else {
      this.columnName = column;
      this.descending = false;
    }
    if (!this.descending) {
      this.orderBy = 'asc';
    } else {
      this.orderBy = 'desc';
    }
  }

  TriggerAction(event:Event){
    this.triggerAction.emit(event);
  }
}
